import Axios from "axios";

export default {
  all(profile, agencyId) { 
    const params = {
      userId: profile.user_id,
      agencyId: agencyId,
    }
    return Axios.get(
      "/quoting/all", {
        params: params
      }
    );
  },
  cotizadores(profile, agencyId) { 
    const params = {
      userId: profile.user_id,
      agencyId: agencyId,
    }
    return Axios.get(
      "/quoting/cotizadores", {
        params: params
      }
    );
  },

  external(profile, agencyId) { 
    if(profile)
    {
      const params = {
        userId: profile.user_id,
        agencyId: agencyId,
      }
      return Axios.get(
        "/quoting/external", {
          params: params
        }
      );
    }
    else{
      localStorage.clear()
      this.store.dispatch("logoutUser");
      this.router.push('/session/login')
      location.reload();
    }

  }
};